var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "class-page",
      staticStyle: { padding: "15px" },
      attrs: { id: "classPage" }
    },
    [
      _c("class-page-header", {
        attrs: {
          details: _vm.details,
          "current-section": parseInt(_vm.sectionId),
          course: _vm.course,
          menu: _vm.menu,
          "is-class-item-page": true
        }
      }),
      _vm._v(" "),
      !!_vm.LTI.report_name
        ? _c("div", { staticClass: "class-page-body" }, [
            _c("h2", [_vm._v(_vm._s(_vm.LTI.report_name))]),
            _vm._v(" "),
            _vm.LTI.displaySetting === "iframe" && !_vm.LTI.debug
              ? _c(
                  "div",
                  [
                    _c("vue-friendly-iframe", {
                      ref: "LTI",
                      staticClass: "viewport",
                      staticStyle: {
                        width: "80vw",
                        height: "80vh",
                        border: "none"
                      },
                      attrs: { className: "LTI", src: _vm.LTI.launchURL },
                      on: { load: _vm.setData }
                    })
                  ],
                  1
                )
              : _c("div", [
                  _c(
                    "form",
                    {
                      ref: "LTIForm",
                      attrs: {
                        id: "auto_submit",
                        action: _vm.LTI.authURL,
                        method: "GET"
                      }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.LTI.iss,
                            expression: "LTI.iss"
                          }
                        ],
                        attrs: { name: "iss", type: "hidden" },
                        domProps: { value: _vm.LTI.iss },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.LTI, "iss", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.LTI.target_link_uri,
                            expression: "LTI.target_link_uri"
                          }
                        ],
                        attrs: { name: "target_link_uri", type: "hidden" },
                        domProps: { value: _vm.LTI.target_link_uri },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.LTI,
                              "target_link_uri",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.LTI.login_hint,
                            expression: "LTI.login_hint"
                          }
                        ],
                        attrs: { name: "login_hint", type: "hidden" },
                        domProps: { value: _vm.LTI.login_hint },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.LTI, "login_hint", $event.target.value)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.LTI.lti_message_hint,
                            expression: "LTI.lti_message_hint"
                          }
                        ],
                        attrs: { name: "lti_message_hint", type: "hidden" },
                        domProps: { value: _vm.LTI.lti_message_hint },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.LTI,
                              "lti_message_hint",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  !!_vm.LTI.debug
                    ? _c("div", [
                        _vm._v(
                          "\n                    " + _vm._s(_vm.LTI.launchURL)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                    " + _vm._s(_vm.LTI.login_hint)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.LTI.lti_message_hint)
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: {
                              type: "button",
                              onclick:
                                "document.getElementById('auto_submit').submit();"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("MAIN_CONTENT.LTILaunch.go")) +
                                "\n                    "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("class-page-footer", {
        attrs: {
          course: _vm.course,
          menu: _vm.menu,
          "current-section": parseInt(_vm.sectionId),
          "is-class-item-page": true
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }